import { GridCellProps } from "@progress/kendo-react-grid"
import React from "react"
import { GridButton } from "../../../../../components"
import { RefundService } from "../../../../../utils/ServiceLocator"
import { Delete, Download } from "@mui/icons-material";
import { Stack } from "@mui/material";
import { useDocumentRemoveMutation } from "../../../../../services/refundService/refund-api";
import { useParams } from "react-router";
import { RefundDocRemoveCommand } from "../../../../../services/refundService/commands";

function RefundDownloadCommand(props:GridCellProps){
    const {caseId,refundId} = useParams();
    const [remove]=useDocumentRemoveMutation();
    const handleDownload=()=>{
        fetch(RefundService + 'DocumentDownloadEndoint/DocumentDownload/'+props.dataItem.id,{method:'GET'})
            .then((response)=>response.blob())
            .then((blob)=>{
                if(props.dataItem.extension==='.pdf'){
                    const file = new Blob([blob], { type: 'application/pdf' });
                    const url = window.URL.createObjectURL(file);
                    window.open(url);
                }
                else{
                const url = window.URL.createObjectURL(new Blob([blob]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download',props.dataItem.fileName);
                document.body.appendChild(link);
                link.click();
                link.parentNode?.removeChild(link);
                }
            });
    };

    return<React.Fragment>
        <Stack direction='row' spacing={'-20px'}>
        <GridButton
            onClick={()=>handleDownload()}>
                {<Download/>}
        </GridButton>
        <GridButton color='error'
            onClick={()=>remove(new RefundDocRemoveCommand(caseId!,refundId!,props.dataItem.id))}>
            {<Delete/>}
        </GridButton>
        </Stack>

    </React.Fragment>
}

export {RefundDownloadCommand}